export function reviewsScroll() {
	let thumbnails = $(".reviews-thumbnails");
	let reviews = $(".reviews-slider");
  thumbnails.mCustomScrollbar({
		axis:"x",
		theme:"dark-thin",
		autoExpandScrollbar:false,
		advanced:{autoExpandHorizontalScroll:true}
	});
	let item = thumbnails.find('.item');
  item.on('click', function () {
  	let $this = $(this);
  	if(!$this.hasClass('active')){
      reviews.find('.active').removeClass('active');
      let index = $this.index();
      $(reviews.find('.item')[index]).addClass('active');
      thumbnails.find('.item').removeClass('active');
      $this.addClass('active');
      thumbnails.mCustomScrollbar("scrollTo", $this);
    }
  })
}


// WEBPACK FOOTER //
// ./assets/js/modules/reviewsScroll.js